import { Button, Switch, Table, TableContainer, Tbody, Td, Th, Thead, Tr, useToast, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure, } from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


const UsersTable = ({ data, search, loading, setFetchAgain }) => {
	const { isOpen, onOpen, onClose } = useDisclosure()

	const [id, setId] = useState("");
	const [name, setName] = useState("");
	const [username, setusername] = useState("");
	const [password, setPassword] = useState();
	const [authorized, setAuthorized] = useState(true);
	const [picLoading, setPicLoading] = useState(false);

	const { user } = ChatState();

	const toast = useToast();

	const openModal = (userInfo) => {
		setId(userInfo ? userInfo._id : "");
		setName(userInfo ? userInfo.name : "");
		setusername(userInfo ? userInfo.username : "");
		setPassword('');
		setAuthorized(userInfo ? userInfo.authorized : true);
		setPicLoading(false);
		onOpen()
	}

	const deleteUser = async (id) => {


		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
				params: { id: id }

			};

			await axios.delete(
				'/api/user',
				config
			);

			toast({
				title: "Supprimé avec succès",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setFetchAgain(true);
		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
		}
	}



	const updateUser = async () => {
		if (!name || !username) {
			toast({
				title: "Veuillez remplir tous les champs",
				status: "warning",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setPicLoading(false);
			return;
		}
		setPicLoading(true);

		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
			};
			await axios.put(
				"/api/user",

				{
					id,
					name,
					username,
					authorized,
					password
				},
				config
			);

			toast({
				title: "Mise à jour réussie",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});


			//  history.push("/chats");
			setFetchAgain(true);



		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});

		}
		onClose();
	};


	return (
		<>
			{/* <Button ml={4} ref={finalRef}>
        I'll receive focus on close
    </Button> */}

			<Modal
				//initialFocusRef={initialRef}
				// finalFocusRef={finalRef}
				isOpen={isOpen}
				onClose={onClose}
			>
				<ModalOverlay />
				<ModalContent m='auto'>
					<ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-image-portrait  mr-2 text-3xl"></i> Utilisateur</ModalHeader>
					<ModalCloseButton />
					<ModalBody pb={6}>
						<FormControl mt={2}>
							<Input id='name' placeholder='Nom et prenom' value={name}
								onChange={(e) => setName(e.target.value)} />
						</FormControl>
						<FormControl mt={2}>

							<Input placeholder='Username' id='username' value={username}
								onChange={(e) => setusername(e.target.value)} />
						</FormControl>
						<FormControl mt={4}>
							<Input placeholder='mot de passe' id='password'
								onChange={(e) => setPassword(e.target.value)} />
						</FormControl>
						<FormControl mt={4} display='flex' alignItems='center'>
							<FormLabel htmlFor='authorized' mb='0'>
							Activer/Arrêter d'utiliser l'application
							</FormLabel>
							<Switch id='authorized' defaultChecked={authorized}
								onChange={(e) => setAuthorized(e.target.checked)} />
						</FormControl>

					</ModalBody>

					<ModalFooter>
						<Button colorScheme='blue' mr={3}
							onClick={updateUser}
							isLoading={picLoading}>
							Enregistrer
						</Button>
						<Button onClick={onClose}>Annuler</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
			<TableContainer w={"full"} className='border'>
				<Table variant={"simple"} >

					<Thead>
						<Tr className="bg-gray-50 text-black">
							<Th textAlign={"center"}>Nom et prenom</Th>
							<Th textAlign={"center"}>Username</Th>
							<Th textAlign={"center"}>Autorisiert</Th>
							<Th w={"24"}></Th>
						</Tr>
					</Thead>
					<Tbody >

						{data?.filter((user) => {
							return search.toLowerCase() === ''
								? user
								: user.name.toLowerCase().includes(search.toLowerCase());
						})
							.map((user, index) => (

								<Tr key={index} fontSize="sm">
									<Td textAlign={"center"}>{user.name}</Td>
									<Td textAlign={"center"}>{user.username}</Td>
									<Td textAlign={"center"} fontSize={'xl'}>
										{
											user.authorized
												? <i className="fa-solid fa-check text-green-600"></i>
												: <i className="fa-solid fa-xmark text-red-600"></i>

										}
									</Td>
									<Td >
										{/* <User_crud tittle='edit' userInfo={user} setFetchAgain={setFetchAgain} /> */}
										<Button bg='gray.50' onClick={() => { openModal(user) }}> <i className="fa-regular fa-pen-to-square text-blue-400 mr-2"></i> Modifier
										</Button>

										<Button fontSize={14} ml={2} bg='gray.50' onClick={() => deleteUser(user._id)}  ><i className="fa-solid fa-trash text-red-500"></i></Button>
									</Td>
								</Tr>

							))}


					</Tbody>


				</Table>
				<div className="w-full  flex item-center p-6">
					{loading && <i className="fa-solid fa-circle-notch animate-spin m-auto text-xl"></i>}
					{!loading && data.length === 0 && <span className="text-md text-gray-300 m-auto">Aucun résultat.</span>}
				</div>
			</TableContainer>
		</>
	);


};

export default UsersTable;
